import React from 'react';
import ProductLoading from './ProductLoading';
import ProductItem from '../../../../shared/components/ProductItem/Index';
import OffertItem from '../../../../shared/components/OffertItem/Index';
import { PRODUCT, OFFERT } from '../../../../shared/types/productType'

import './styles.css';

export default function Index(props) {

    if (props.loading)
        return (<ProductLoading />);

    return (
        <div className="row">
            {
                props.products.map(item => {
                    if (item.productType === PRODUCT)
                        return (<ProductItem key={item.id} item={item} columns={3} />);

                    if (item.productType === OFFERT)
                        return (<OffertItem key={item.id} item={item} columns={3} />);

                    return null;
                })
            }
        </div>
    );
}